import { Button, Input, notification, Empty, Modal } from 'antd'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import NewService from 'services/StationsNewsServiceFunctions'
import * as sc from './StationsLayout.styled'
import { StickyHeaderContainer } from 'components/elements/header'
import { CopyOutlined, DownOutlined } from '@ant-design/icons'
import './index.scss'
import { ReactComponent as ArrowBottomBIDV } from '../../assets/icons/BIDV/arrow-bottom.svg'
import { xoa_dau } from 'helper/common'
import BookingService from 'services/addBookingService'
import { useLocation } from 'react-router-dom'
import _, { get, set } from 'lodash'
import { STATION_TYPE } from './../../constants/global'
import SearchList from 'components/shared/search/SearchList'
import './index.scss'
import AreaByIP from 'services/getAreaByIP'
import {
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon
} from 'react-share'
import PopupMessage from 'components/PopupMessageAlert'
import BasicPopupList from 'components/BasicComponent/BasicPopupList'
import LoadingPopup from 'components/LoadingPopup'
import BasicTablePaging from 'components/BasicComponent/BasicTablePaging'
import { useSelector } from 'react-redux'
import { BANNER_TYPE } from 'constants/banner'
import { getBannerBySectionCache } from 'helper/getBannerBySectionCache'
import { useTranslation } from 'react-i18next'
import { ClickCountableArea } from 'components/BasicComponent/ClickCountableArea'
import { TARGET_ID } from 'constants/targetList'
import PostNewsFeedCard from 'components/PostNewsFeedCard'
import { mapStationToPost } from 'components/PostNewsFeedCard/model'
import DrawerBookingPartnerFromUrl from 'components/DrawerBookingPartnerFromUrl'
import UserVihcleService from 'services/userVihcleService'
import { FunctionPostCTA } from 'pageUtililiy/functionPostCTA'
import addKeyLocalStorage from 'helper/localStorage'
import ChooseCarDrawer from './chooseCarModal'
import RatePopup from './RatePopup'
import companyInfo from 'constants/companyInfo'
import StickyHeader from 'components/elements/header'
import IframeMiniApp from 'components/IframeMiniApp'
import BidvArrowLeft from 'assets/icons/icon_ht_arrow-left.png'
import BidvCancelIcon from 'assets/icons/icon_ht_cancel.png'
import NoDataAvailable from 'assets/icons/no_data_available.png'
import { useAppParamsContext } from 'contexts/AppParamsContext'
const LIMIT = 20

export const StationsLayout = ({ history }) => {
  // const [currentMap, setCurrentMap] = useState()
  const location = useLocation()
  const { t: translation } = useTranslation()
  const searchparam = location.search
  const params = new URLSearchParams(searchparam)
  const [stations, setStations] = useState({})
  const [changeField, setChangeField] = useState('')
  const [isOpenSelectionModal, setIsOpenSelectionModal] = useState(false)
  const [currentStation, setCurrentStation] = useState()
  const [detailStationBtn, setDetailStationBtn] = useState(false)
  const [stationId, setStationId] = useState('')
  const [totalData, setTotalData] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [firstPage, setFirstPage] = useState(false)
  const [isModalErrOpen, setIsModalErrOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [stationsType, setStationsType] = useState(params.get('type') || STATION_TYPE.TTDK.stationType)
  const [stationsName, setStationsName] = useState(params.get('name') || translation('list-station'))
  const [stationArea, setStationArea] = useState(params.get('area') || undefined)
  const [searchText, setSearchText] = useState(params.get('searchtext') || '')
  // const [selectedStation, setSelectedStation] = useState({})
  const d = new Date()
  let dayOfWeek = d.getDay() - 1
  const [filter, setFilter] = useState({
    limit: LIMIT,
    searchText: searchText,
    skip: 0,
    filter: {
      stationType: stationsType,
      stationArea: stationArea
    }
  })
  const [isVisible, setIsVisible] = useState(false)
  const [area, setArea] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [shareUrl, setShareUrl] = useState('')
  const { isHeaderMiniApp, isEmbeddedView, appThemeName } = useAppParamsContext()
  const stationThemeName = String(appThemeName || '').toUpperCase()
  const isStationThemeEnabled = ['BIDV'].includes(stationThemeName) // Khi nào thêm mới thì thêm vào đây  ['BIDV', 'THEME_MOI']
  const [listStationArea, setListStationArea] = useState([])
  // Phần thông tin người dùng
  const auth = useSelector((state) => state.authReducer)
  const user = auth?.data
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [link, setLink] = useState('')
  const [isOpenChoosingCarModal, setIsOpenChoosingCarModal] = useState(false)
  const [dataVehicle, setDataVehicle] = useState([])
  const [selectedLisencePlate, setSelectedLisencePlate] = useState('')
  const [selectedStationsId, setSelectedStationsId] = useState('')
  // Phần đánh giá
  const [isRate, setIsRate] = useState(false)
  const [detail, setDetail] = useState({})
  const [ratePoint, setRatePoint] = useState(0)
  const [showRate, setShowRate] = useState(true)

  const [dataIframeMiniApp, setDataIframeMiniApp] = useState({
    urlIframe: '',
    title: ''
  })

  const [stationsBanner, setStationsBanner] = useState([])
  const CLICK_STATIONS_TYPE = () => {
    switch (stationsType) {
      case '1':
        return TARGET_ID.CENTER.id
      case '2':
        return TARGET_ID.INTERNAL.id
      case '3':
        return TARGET_ID.GARAGE.id
      case '4':
        return TARGET_ID.INSPECTION_RESCUE.id
      case '5':
        return TARGET_ID.INSURANCE_COMPANY.id
      case '6':
        return TARGET_ID.CONSULTING.id
      case '7':
        return TARGET_ID.AFFILIATE.id
      case '8':
        return TARGET_ID.ADVERTISING.id
      case '9':
        return TARGET_ID.TRANSPORT_COOPERATIVE.id
      case '10':
        return TARGET_ID.USED_CAR_TRADING.id
      case '11':
        return TARGET_ID.SPARE_PARTS_DEALERSHIP.id
      case '12':
        return TARGET_ID.PARKING_LOT.id
      case '13':
        return TARGET_ID.VEHICLE_RENOVATION_COMPANY.id
      case '14':
        return TARGET_ID.DRIVING_SCHOOL.id
      case '15':
        return TARGET_ID.CHAUFFEUR_SERVICE.id
      case '16':
        return TARGET_ID.PARTS_MANUFACTURING_CONSULTANCY.id
      case '17':
        return TARGET_ID.DRIVER_HEALTH.id
      case '18':
        return TARGET_ID.CAR_EVALUATION_SERVICE.id
      default:
        return TARGET_ID.CENTER.id
    }
  }

  const scrollAppToTop = () => {
    const app = document.querySelector('#body-root')
    if (!app) return

    // webview / miniapp ăn chắc
    app.scrollTop = 0

    // browser thường
    app.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  const getVihcle = () => {
    return UserVihcleService.getListVihcle({
      filter: {
        appUserId: user?.appUserId
      }
    }).then((result) => {
      const { isSuccess, data } = result
      if (isSuccess && data?.data.length > 0) {
        return data?.data
      }
    })
  }

  useEffect(() => {
    getBannerBySectionCache(BANNER_TYPE[stationsType]).then((data) => {
      setStationsBanner(data)
    })
    if (user?.appUserId) {
      try {
        getVihcle()
          .then((result) => {
            if (result && result.length > 0) {
              const dataVihicleFormatted = result.map((item) => {
                return {
                  label: item.vehicleIdentity,
                  value: item.vehicleIdentity,
                  appUserVehicleId: item.appUserVehicleId,
                  vehicleSubType: item.vehicleSubType,
                  vehicleSubCategory: item.vehicleSubCategory
                }
              })
              setDataVehicle(dataVihicleFormatted)
              localStorage.setItem(addKeyLocalStorage('listVehicle'), JSON.stringify(result))
            } else {
              localStorage.removeItem(addKeyLocalStorage('selectedLisencePlate'))
              setDataVehicle([])
              setSelectedLisencePlate('')
            }
          })
          .catch((error) => {})
          .finally(() => {})
      } catch (error) {}
    }
  }, [])

  const handleCoppyLink = (textToCopy) => {
    handleCancel()
    setIsModalErrOpen(true)
    setErrorMessage('Sao chép thành công!')
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy)
    } else {
      // text area method
      let textArea = document.createElement('textarea')
      textArea.value = textToCopy
      // make the textarea out of viewport
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand('copy') ? res() : rej()
        textArea.remove()
      })
    }
  }

  const handleSearch = (value) => {
    setCurrentPage(1)
    setFirstPage(!firstPage)
    setSearchText(value)
    setFilter({ ...filter, limit: 20, searchText: value, skip: 0 })
  }
  const handleChangePage = (pageNum) => {
    setCurrentPage(pageNum)
    const skip = pageNum * LIMIT - LIMIT
    setFilter({ ...filter, skip: skip })
  }
  useEffect(() => {
    getAreaByIP()
    getStationAreas()
    function handleScroll() {
      const footerEl = document.querySelector('footer')
      let footerHeight = 0
      if (footerEl) {
        footerHeight = footerEl.clientHeight
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    getStation(filter)
  }, [filter])
  const getAreaByIP = () => {
    AreaByIP.getAreaByIP().then((result) => {
      const { statusCode, data } = result
      if (statusCode == 200) {
        if (data.stationArea) {
          filter.filter.stationArea = data.stationArea
          setArea(data.stationArea)
          setFilter({ ...filter })
        }
      }
      return result
    })
  }
  const getStationAreasList = (searchText) => {
    if (!searchText) {
      getStationAreas()
    }
    let items = []
    const searchNoDiacritics = searchText ? xoa_dau(searchText.toLowerCase()) : ''
    listStationArea.map((item) => {
      if (xoa_dau(item.value.toLowerCase()).indexOf(searchNoDiacritics) !== -1) {
        items.push(item)
      }
    })
    if (items.length > 0) {
      setListStationArea(items)
    } else {
      setListStationArea([])
    }
  }
  const getStationData = (area) => {
    setArea(area.value)
    let newFilter = {
      ...filter.filter,
      stationArea: area.value
    }
    if (!area.code) {
      newFilter = {
        ...filter.filter,
        stationArea: undefined
      }
    }
    setFilter({
      ...filter,
      filter: newFilter,
      skip: 0
    })
    setCurrentPage(1)
    setFirstPage(!firstPage)
  }
  function getStationAreas() {
    BookingService.getStationAreaList()
      .then((data) => {
        let tmp = data || []
        if (tmp.length > 0)
          tmp.forEach((element) => {
            element.label = <div style={{ fontWeight: 'normal' }}>{element.value}</div>
            element.value = element.value
          })
        setListStationArea([
          ...[
            {
              label: <div style={{ fontWeight: 'normal' }}>{translation('all-vntId')}</div>,
              value: 'Tất cả khu vực'
            }
          ],
          ...tmp
        ])
      })
      .catch(() => {
        notification.error(translation('get-data-fail'))
      })
  }

  const queueRef = useRef(Promise.resolve())
  const latestIdRef = useRef(0)

  const getStation = (filter) => {
    const requestId = ++latestIdRef.current

    queueRef.current = queueRef.current.then(async () => {
      setIsVisible(true)

      const result = await NewService.getStationsList(filter)

      // chỉ request cuối được update UI
      if (requestId === latestIdRef.current && result) {
        scrollAppToTop()
        setStations((prev) => ({
          ...prev,
          ...result
        }))
        setTotalData(result.total)

        if (result?.data?.[0]) {
          setCurrentStation(`${result.data[0].stationsName}-${result.data[0].stationUrl}`)
        }
      }

      setIsVisible(false)
    })

    return queueRef.current
  }

  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    setTimeout(() => {
      if (detailStationBtn) {
        history.push(`/station/${stationId}${searchparam || ''}`)
      }
    }, 100)
  }, [detailStationBtn])

  useEffect(() => {
    const appUserVehicleId = selectedLisencePlate?.appUserVehicleId
    selectedLisencePlate &&
      selectedStationsId &&
      handleActionCTA(appUserVehicleId, selectedStationsId).then((bookingUrl) => {
        if (bookingUrl) {
          if (isHeaderMiniApp) {
            setDataIframeMiniApp({
              title: 'Thông tin lịch hẹn',
              urlIframe: bookingUrl + '&isWebView=1'
            })
          } else {
            setLink(bookingUrl)
            setIsModalVisible(true)
          }
          return
        }
      })
  }, [selectedLisencePlate])

  const searchVehicle = (value) => {
    if (user?.appUserId) {
      return UserVihcleService.getListVihcle({
        searchText: value
      }).then((result) => {
        const { isSuccess, data } = result
        if (isSuccess && data?.data.length > 0) {
          setDataVehicle(
            data.data.map((item) => ({
              label: item.vehicleIdentity,
              value: item.vehicleIdentity,
              appUserVehicleId: item.appUserVehicleId,
              vehicleSubType: item.vehicleSubType,
              vehicleSubCategory: item.vehicleSubCategory
            }))
          )
        }
      })
    }
  }

  const handleActionCTA = async (vehicleId, stationsId) => {
    setIsVisible(true)
    return FunctionPostCTA({ vehicleId, stationsId })
      .then((response) => {
        return response
      })
      .catch((error) => {})
      .finally(() => {
        setIsVisible(false)
      })
  }

  const renderStations = useMemo(() => {
    if (!stations.data || stations.data.length === 0)
      return (
        <div
          className={`stations-empty ${
            isStationThemeEnabled ? 'stations-empty-bidv' : ''
          }`}>
          <Empty
            image={isStationThemeEnabled ? NoDataAvailable : undefined}
            description="Hiện tại chưa có trung tâm phù hợp"
          />
        </div>
      )

    return stations.data.map((item, i) => {
      if (_.isEmpty(item)) return <></>
      const active = item?.stationsName + '-' + item?.stationUrl === currentStation

      let functionCTA = async () => {
        setSelectedStationsId(item.stationsId)
        // Hiện tại quản lý đã bỏ logic này
        // if (item?.introCtaLink) {
        //   return window.open(item?.introCtaLink, '_blank')
        // }

        if (+item.introCtaAction === 1) {
          if (
            !JSON.parse(localStorage.getItem(addKeyLocalStorage('listVehicle'))) ||
            JSON.parse(localStorage.getItem(addKeyLocalStorage('listVehicle'))).length === 0
          ) {
            const bookingUrl = await handleActionCTA(_, item.stationsId)
            if (isHeaderMiniApp) {
              setDataIframeMiniApp({
                title: 'Thông tin lịch hẹn',
                urlIframe: bookingUrl + '&isWebView=1'
              })
            } else {
              setLink(bookingUrl)
              setIsModalVisible(true)
            }
            return
          }
          if (JSON.parse(localStorage.getItem(addKeyLocalStorage('listVehicle'))).length > 0) {
            setLink('')
            setIsOpenChoosingCarModal(true)
          }
        } else {
          return history.push(`/station/${item.stationCode}${searchparam || ''}`)
        }
      }

      return (
        <div
          key={`${item?.stationsName}-${item?.stationUrl}-${i}`}
          className={[active ? 'active' : '', !item?.stationMapSource ? 'disabled' : ''].join(' ') + ''}
          onClick={() => {
            setCurrentStation(`${item?.stationsName}-${item?.stationUrl}`)
          }}>
          <PostNewsFeedCard
            post={mapStationToPost(item)}
            key={item?.stationCode}
            stationType={item?.stationType}
            functionCTA={functionCTA}
            // phần đánh giá
            setDetail={setDetail}
            setIsRate={setIsRate}
          />
        </div>
      )
    })
  }, [stations, currentStation])

  return (
     <div className="bg-background custom-container">
      <sc.Container className={isStationThemeEnabled ? 'stations-theme-page stations-theme-enabled' : 'stations-theme-page'}>
        {isVisible && <LoadingPopup />}
        <StickyHeader
          className={isStationThemeEnabled ? 'station-themed-topbar' : ''}
          showLogo={false}
          showArrowLeft={true}
          title={translation(stationsName)}
          backIcon={isStationThemeEnabled ? BidvArrowLeft : null}
          borderColor="transparent"
        />
        {!isEmbeddedView && (
          <div>
            {stationsBanner?.length ? (
              <div className={`bottom-banner`} style={{ overflow: 'hidden' }}>
                <ClickCountableArea
                  Id={CLICK_STATIONS_TYPE()}
                  className="custom-slide"
                  link={stationsBanner[0]?.bannerUrl || '#'}
                  target={stationsBanner[0]?.bannerUrl ? '_blank' : '_self'}>
                  <img src={stationsBanner[0].bannerImageUrl} alt={stationsBanner[0].bannerName} width={'100%'} />
                </ClickCountableArea>
              </div>
            ) : (
              <></>
            )}
          </div>
        )}
        <div className="search-item">
          <div className="search-form d-flex ai-c j-sb search">
            <SearchList placeholder={translation('input-station')} className="search search-input w-100" onSearch={handleSearch} />
          </div>
          <div
            className="search-form"
            onClick={() => {
              setIsOpenSelectionModal(true)
              setChangeField('vntStation')
            }}>
            <Input
              className="cs-select c-ss"
              isSearchable={true}
              readOnly
              value={area}
              filterOption={(input, option) => {
                return xoa_dau((option?.value ?? '').toLowerCase()).includes(xoa_dau(input.toLowerCase()))
              }}
              placeholder={translation('vntId')}
              options={listStationArea}
              suffix={isStationThemeEnabled ? <ArrowBottomBIDV className="dropdown-icon" />   :<DownOutlined className="dropdown-icon" />}
            />
          </div>
        </div>
        <div className="custom-content-style px-0 bg-secondary">
          <div>
            <sc.StationContainer>
              <div className="">
                {renderStations}
                {(stations?.data?.length > 0 || (stations?.data?.length === 0 && currentPage !== 1)) && (
                  <BasicTablePaging handlePaginations={handleChangePage} firstPage={firstPage} count={totalData === 0} />
                )}
              </div>
            </sc.StationContainer>
            <Modal
              title={translation('share')}
              style={{ maxWidth: '280px', width: '100%' }}
              footer={false}
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}>
              <div style={{ justifyContent: 'center', display: 'flex', gap: '15px' }}>
                <FacebookShareButton url={shareUrl}>
                  <FacebookIcon onClick={() => handleCancel()} size={40} round={true}></FacebookIcon>
                </FacebookShareButton>
                <EmailShareButton url={shareUrl} subject={`Trung tâm đăng kiểm ô tô - ${companyInfo?.shortName}`}>
                  <EmailIcon onClick={() => handleCancel()} size={40} round={true}></EmailIcon>
                </EmailShareButton>
                <TelegramShareButton url={shareUrl}>
                  <TelegramIcon onClick={() => handleCancel()} size={40} round={true}></TelegramIcon>
                </TelegramShareButton>
                <TwitterShareButton url={shareUrl}>
                  <TwitterIcon onClick={() => handleCancel()} size={40} round={true}></TwitterIcon>
                </TwitterShareButton>
                <Button className="btn-coppy" onClick={() => handleCoppyLink(shareUrl)}>
                  <CopyOutlined style={{ fontSize: '18px' }} />
                </Button>
              </div>
            </Modal>
            {isModalErrOpen && (
              <PopupMessage
                isModalOpen={isModalErrOpen}
                history={history}
                onClose={() => {
                  setIsModalErrOpen(false)
                }}
                text={errorMessage}></PopupMessage>
            )}
            {isStationThemeEnabled ? (
              <ChooseCarDrawer
                listData={listStationArea}
                title={translation('choose-vntId')}
                showSearch
                isOpenPopupList={isOpenSelectionModal}
                onSearchCallback={getStationAreasList}
                onSelectedItemChanged={getStationData}
                closeIcon={
                  <img
                    src={BidvCancelIcon}
                    className="bidv-bottom-sheet-close-icon"
                    alt="Đóng"
                  />
                }
                onClose={() => {
                  setIsOpenSelectionModal(false)
                }}
              />
              ) : (
                <BasicPopupList
                  listData={listStationArea}
                  title={translation('choose-vntId')}
                  changeField={changeField}
                  onSearchCallback={getStationAreasList}
                  showSearch
                  isOpenPopupList={isOpenSelectionModal}
                  onSelectedItemChanged={getStationData}
                  onClose={() => {
                    setIsOpenSelectionModal(false)
                  }}
                />
              )}
          </div>
        </div>
      </sc.Container>
      <DrawerBookingPartnerFromUrl isOpen={isModalVisible} onCancel={() => setIsModalVisible(false)} link={link} className="drawer-no-padding-x" />
      {dataIframeMiniApp?.urlIframe && (
        <IframeMiniApp
          urlIframe={dataIframeMiniApp?.urlIframe}
          title={dataIframeMiniApp?.title}
          onClose={() => {
            setDataIframeMiniApp({})
            setSelectedLisencePlate(null)
          }}
        />
      )}
      <ChooseCarDrawer
        listData={dataVehicle}
        title={translation('choose-vehicle')}
        filter={null}
        setFilter={() => {}}
        changeField={'vehicleIdentity'}
        showSearch
        isOpenPopupList={isOpenChoosingCarModal}
        onClose={() => setIsOpenChoosingCarModal(false)}
        onSearchCallback={(value) => searchVehicle(value)}
        onSelectedItemChanged={setSelectedLisencePlate}></ChooseCarDrawer>
      <RatePopup isRate={isRate} setIsRate={setIsRate} detail={detail} ratePoin={ratePoint} setRatePoin={setRatePoint} showRate={showRate} />
    </div>
  )
}
